export function getDefaultLocaleCurrentDomain() {
  switch (window.location.hostname) {
    case 'beta.eu.learning.warehousejobs.in':
    case 'gamma.eu.learning.warehousejobs.in':
    case 'learning.warehousejobs.in':
    case 'localhost':
      return 'en-IN';
    default:
      return 'en-US';
  }
}

/**
 * Maps a locale string to its corresponding language name
 * @param locale Locale string (e.g., 'hi-IN', 'en-IN')
 * @returns The language name ('Hindi' or 'English')
 */
export const mapLocaleToLanguage = (locale: string): string => {
  if (!locale) return 'English';

  // Extract language code from locale (e.g., 'hi-IN' -> 'hi', 'en-IN' -> 'en')
  const languageCode = locale.split('-')[0].toLowerCase();

  switch (languageCode) {
    case 'hi':
      return 'Hindi';
    case 'en':
    default:
      return 'English';
  }
};
